import { render, staticRenderFns } from "./MoveBatch.vue?vue&type=template&id=13387554&scoped=true"
import script from "./MoveBatch.vue?vue&type=script&lang=js"
export * from "./MoveBatch.vue?vue&type=script&lang=js"
import style0 from "./MoveBatch.vue?vue&type=style&index=0&id=13387554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13387554",
  null
  
)

export default component.exports